import { observable } from 'mobx';
import type { HotelElementResponseArgs } from './hotel_element2';
import HotelElement, { convertHotelElementResponseToArgs } from './hotel_element2';
import type { NonOrderItemPriceResponseArgs } from './non_order_item_price2';
import NonOrderItemPrice, { convertNonOrderItemPriceResponseToArgs } from './non_order_item_price2';
import type { NonOrderItemMappingResponseArgs } from './non_order_item_mapping2';
import NonOrderItemMapping, { convertNonOrderItemMappingResponseToArgs } from './non_order_item_mapping2';
import type { TransportElementResponseArgs } from './transport_element2';
import TransportElement, { convertTransportElementResponseToArgs } from './transport_element2';

export type NonOrderItemResponseArgs = {
  id: number;
  price: NonOrderItemPriceResponseArgs;
  people_num: number;
  non_order_item_mappings?: NonOrderItemMappingResponseArgs[];
  transports?: TransportElementResponseArgs[];
  hotels?: HotelElementResponseArgs[];
  request_type?: string;
  trip_type_text?: string;
};

export type NonOrderItemArgs = {
  id: number;
  price: NonOrderItemPrice;
  peopleNum: number;
  nonOrderItemMappings: NonOrderItemMapping[];
  transports: TransportElement[];
  hotels: HotelElement[];
  requestType?: string;
  tripTypeText?: string;
};

export const convertNonOrderItemResponseToArgs = (response: NonOrderItemResponseArgs) => {
  const args: NonOrderItemArgs = {
    id: response.id,
    price: new NonOrderItemPrice(convertNonOrderItemPriceResponseToArgs(response.price)),
    peopleNum: response.people_num,
    nonOrderItemMappings: response.non_order_item_mappings
      ? response.non_order_item_mappings.map(
          mapping => new NonOrderItemMapping(convertNonOrderItemMappingResponseToArgs(mapping))
        )
      : [],
    transports:
      response.transports?.map(r => new TransportElement(convertTransportElementResponseToArgs(r))) || [],
    hotels: response.hotels?.map(r => new HotelElement(convertHotelElementResponseToArgs(r))) || [],
    requestType: response.request_type,
    tripTypeText: response.trip_type_text
  };
  return args;
};

export default class NonOrderItem {
  @observable id: number;
  @observable price: NonOrderItemPrice;
  @observable peopleNum: number;
  @observable nonOrderItemMappings: NonOrderItemMapping[];
  @observable transports: TransportElement[];
  @observable hotels: HotelElement[];
  @observable elements: (TransportElement | HotelElement)[];

  @observable
  requestType?: string;

  @observable
  tripTypeText?: string;

  constructor(args: NonOrderItemArgs) {
    this.id = args.id;
    this.price = args.price;
    this.peopleNum = args.peopleNum;
    this.nonOrderItemMappings = args.nonOrderItemMappings;
    this.transports = args.transports;
    this.hotels = args.hotels;
    this.elements = [...this.transports, ...this.hotels];
    this.requestType = args.requestType;
    this.tripTypeText = args.tripTypeText;
  }

  get totalPrice() {
    if (this.hotels.length > 0) {
      return this.price.totalPrice * this.hotels[0].roomNum;
    }
    return this.price.totalPrice * this.peopleNum;
  }

  get typeStr() {
    return this.hotels.length > 0 ? 'ホテル' : '経路';
  }
}
